import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import CreateCampaignTab from '../../../components/CampaignsComponent/CreateCampaignTab/CreateCampaignTab';
import BillTab from '../../../components/CampaignsComponent/BillTab/BillTab';
import BackButton from '../../../components/common/BackButton';
import {
  Container,
  LayoutContainer,
  TabContainer,
  TabNavigationTab,
} from './CreateCampaignStyles';

const CreateCampaign = () => {
  const initState = {
    create: true,
    bill: false,
  };

  const [tab, setTab] = useState(initState);

  // Assuming you have a campaignSlice and the `createSuccess` flag in the store
  const {createSuccess} = useSelector(state => state.campaign); 

  // Automatically switch to the billing tab when the campaign is successfully created
  useEffect(() => {
    if (createSuccess) {
      setTab({
        create: false,
        bill: true,
      });
    }
  }, [createSuccess]);

  return (
    <Container>
      <BackButton></BackButton>
      <div className='header'>
        <div className='texts'>
          <h3>Create Campaign</h3>
          <p>View your team’s trades and transactions.</p>
        </div>
      </div>
      <LayoutContainer>
        <TabContainer>
          <TabNavigationTab>
            <ul>
              <li>
                <a
                  href='#create-campaigns'
                  className={tab.create ? 'active' : ''}
                  onClick={() =>
                    setTab(tab => ({ ...initState, create: true }))
                  }
                >
                  Create Campaign
                </a>
              </li>
              <li>
                <a
                  href='#billing'
                  className={tab.bill ? 'active' : ''}
                  onClick={() =>
                    setTab(tab => ({
                      ...initState,
                      create: false,
                      bill: true,
                    }))
                  }
                >
                  Billing
                </a>
              </li>
            </ul>
          </TabNavigationTab>
        </TabContainer>

        <div className='tab-content'>
          {tab.create && <CreateCampaignTab />}
          {tab.bill && <BillTab />}
        </div>
      </LayoutContainer>
    </Container>
  );
};

export default CreateCampaign;
